// extracted by mini-css-extract-plugin
export default {"clusterMarker":"styles_clusterMarker__0GbOf"};